<template>
    <div class="budget-followup-ebitda">
        <div v-if="data">

            <div class="accounts-modal" v-if="accountsModal">
                <div class="inner">
                    <div class="inner__title">
                        Underkonti for "{{ accountsModal.name }}"
                    </div>
                    <table style="width:100%;">
                        <thead>
                            <tr>
                                <th align="left">Konto</th>
                                <th align="left">Navn</th>
                                <th align="right" width="20%">Realiseret</th>
                                <th align="right" width="20%">Budget</th>
                                <th align="right" width="20%">Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(account, index) in accountsModal.accounts" :key="'account_' + index">
                                <td align="left">{{ account.account_number }}</td>
                                <td align="left">{{ account.name }}</td>
                                <td align="right">{{ account.real_expenses | currency }}</td>
                                <td align="right">
                                    <span v-if="account.expenses_budget_to_now !== 0">
                                        {{ account.expenses_budget_to_now | currency }}
                                    </span>
                                    <span v-else>-</span>
                                </td>
                                <td align="right">
                                    <span v-if="account.expenses_budget_to_now !== 0">
                                        <!--<span v-if="['Omsætning', 'Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(account.name)">-->
                                            <span :class="{'color-good': (account.real_expenses - account.expenses_budget_to_now) > 0, 'color-bad': (account.real_expenses - account.expenses_budget_to_now) < 0}">
                                                <span v-if="(account.real_expenses - account.expenses_budget_to_now) > 0">+</span>{{ account.real_expenses - account.expenses_budget_to_now | currency }}
                                            </span>
                                        <!--</span>-->
                                    </span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                            <tr style="font-weight:bold;">
                                <td align="left">Total</td>
                                <td align="left"></td>
                                <td align="right">{{ accountsModal.real_expenses | currency }}</td>
                                <td align="right">
                                    <span v-if="accountsModal.expenses_budget_to_now !== 0">
                                        {{ accountsModal.expenses_budget_to_now | currency }}
                                    </span>
                                    <span v-else>-</span>
                                </td>
                                <td align="right">
                                    <span v-if="accountsModal.expenses_budget_to_now !== 0">
                                        <!--<span v-if="['Omsætning', 'Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountsModal.name)">-->
                                            <span :class="{'color-good': (accountsModal.real_expenses - accountsModal.expenses_budget_to_now) > 0, 'color-bad': (accountsModal.real_expenses - accountsModal.expenses_budget_to_now) < 0}">
                                                <span v-if="(accountsModal.real_expenses - accountsModal.expenses_budget_to_now) > 0">+</span>{{ accountsModal.real_expenses - accountsModal.expenses_budget_to_now | currency }}
                                            </span>
                                        <!--</span>-->
                                    </span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="close-wrapper">
                        <button class="budget-btn" @click="accountsModal = null">
                            Luk
                        </button>
                    </div>
                </div>
            </div>

            <div class="placeholder">
                <div class="placeholder__heading">
                    <d-tooltip identifier="budgetfollowup.ebitda" placement="left" />
                    EBITDA
                </div>
                <div class="placeholder padding">
                    <div style="display:flex;justify-content:center;">
                        <div class="employee-switcher" style="margin-bottom:30px;">
                            <div class="employee-switcher-option lg" @click="period = 'budgetyear'" :class="{'selected': period === 'budgetyear'}">
                                Budgetåret til dato
                            </div>
                            <div class="employee-switcher-option lg" @click="period = 'month'" :class="{'selected': period === 'month'}">
                                Denne måned
                            </div>
                        </div>
                    </div>
                    <table style="width:100%">
                        <thead>
                            <tr>
                                <th align="left">Konto</th>
                                <th align="right" width="20%">Realiseret</th>
                                <th align="right" width="20%">Budget</th>
                                <th align="right" width="20%">Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(accountCategory, index) in data.account_categories" :key="'accountCategory_' + index" :class="{'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)}">
                                <td align="left">
                                    <i class="fas fa-list fa-fw" v-if="accountCategory.accounts.length > 0" @click="accountsModal = accountCategory" />
                                    <i class="fas fa-list fa-fw" v-else style="opacity:0;" />
                                    &nbsp;{{ accountCategory.name }}
                                </td>
                                <td align="right">{{ accountCategory.real_expenses | currency }}</td>
                                <td align="right">
                                    <span v-if="accountCategory.expenses_budget_to_now !== 0">
                                        {{ accountCategory.expenses_budget_to_now | currency }}
                                    </span>
                                    <span v-else>-</span>
                                </td>
                                <td align="right">
                                    <span v-if="accountCategory.expenses_budget_to_now !== 0">
                                        <!--<span v-if="['Omsætning', 'Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)">-->
                                            <span :class="{'color-good': (accountCategory.real_expenses - accountCategory.expenses_budget_to_now) > 0, 'color-bad': (accountCategory.real_expenses - accountCategory.expenses_budget_to_now) < 0}">
                                                <span v-if="(accountCategory.real_expenses - accountCategory.expenses_budget_to_now) > 0">+</span>{{ accountCategory.real_expenses - accountCategory.expenses_budget_to_now | currency }}
                                            </span>
                                        <!--</span>-->
                                    </span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>
            <box-loading />
        </div>
    </div>
</template>

<script>
import * as budgetService from '@/services/budgetService'

export default {
    data () {
        return {
            period: 'budgetyear',
            data: null,
            accountsModal: null
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            this.data = null
            this.accountsModal = null
            let params = {
                period: this.period
            }
            budgetService.ebitda(params, (response) => {
                this.data = response.data
            }, (err) => {
                console.log(err)
            })
        }
    },
    watch: {
        period: function () {
            this.getData()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/vars.scss";

.bold {
    font-weight: bold;
}
.accounts-modal {
    z-index: 9999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;

    .inner {
        background: #fff;
        border-radius: $borderradius--main;
        padding: $margin--main;
        width: 800px;
        max-width: 80%;
        max-height: 80%;
        overflow-y: auto;

        &__title {
            font-size: $fontsize--large;
            font-weight: bold;
            margin-bottom: $margin--main;
        }

        .close-wrapper {
            margin-top: $margin--main;
        }
    }
}
table {

    th {
        padding: 4px 4px;

        &:first-of-type {
            padding-left: 0px;
        }
    }

    td {
        padding: 4px 4px;
        border-top: 1px solid #eee;

        i.fa-list {
            opacity: 0.5;
            cursor: pointer;
            transition: 0.3s ease all;

            &:hover {
                opacity: 1;
            }
        }

        &:first-of-type {
            padding-left: 0px;
        }

        &.budget {
            padding: 4px;
            // padding: 0px 0px;
            width: 220px;

            input {
                background: rgba(23,43,67,0.05);
                border-radius: 4px !important;
                padding: 4px !important;
                border-top: none !important;
                border-bottom: none !important;
                border: none !important;
                // border-radius: 0px !important;
                height: 100%;
                width: 200px !important;
                text-align: right;
                width: 100px;
                color: inherit !important;
                font-weight: inherit !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// budgetEbitda.vue?cc231f6c